<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import academicYearApi from '@/services/api/academicyear.api'
import reportApi from '@/modules/report/api'
import providerApi from '@/services/api/provider.api'
import specialistApi from '@/services/api/specialist.api'
import codeApi from '@/services/api/code.api'
import locationApi from '@/services/api/location.api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Registro de Visitas Semanal',
      routes: ["Inicio", "Informes Generales", "Registro de Visitas Semanal"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          companies: [],
          specialists: [],
          serviceTypes: [],
          regions: [],
          months: [],
          weekNumbers: [],
        },
        filters: {
          academicYear: null,
          company: null,
          specialist: null,
          serviceType: null,
          region: null,
          month: null,
          studentSieId: null,
          weekNumber: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        class: "col-12 col-md-4",
        clearable: false,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged: this.onAcademicYearChange,
      },
      {
        name: 'company',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Proveedor',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un proveedor.",
        validations: "required",
        class: "col-12 col-md-4",
        clearable: false,
        options: this.model.search.collections.companies,
        value: this.model.search.filters.company,
        onChanged: this.onProviderChange,
      },
      {
        name: 'specialist',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Especialista',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un especialista.",
        // validations: "required",
        class: "col-12 col-md-4",
        clearable: false,
        options: this.model.search.collections.specialists,
        value: this.model.search.filters.specialist,
      },
      {
        name: 'serviceType',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Servicio',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-12 col-md-4",
        options: this.model.search.collections.serviceTypes,
        value: this.model.search.filters.serviceType,
      },
      {
        name: 'studentSieId',
        label: 'SIE',
        component: 'CustomInput',
        class: "col-12 col-md-4",
        value: this.model.search.filters.studentSieId,
        placeholder: 'Escriba número de SIE',
        type: 'number',
        maskType: 'SIE',
        masked: true,
      },
      {
        name: 'region',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Región',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-12 col-md-4",
        options: this.model.search.collections.regions,
        value: this.model.search.filters.region,
      },
      {
        name: 'month',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Mes',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-12 col-md-4",
        options: this.model.search.collections.months,
        value: this.model.search.filters.month,
      },
      {
        name: 'weekNumber',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Número de Semana',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-12 col-md-4",
        options: this.model.search.collections.weekNumbers,
        value: this.model.search.filters.weekNumber,
      },
    ]},
  },
  watch: {
    async 'model.search.filters.academicYear'(newValue) {
      this.model.search.filters.weekNumber = null;

      if (!newValue?.id) {
        this.model.search.collections.weekNumbers = [];        
        return;
      }

      const { data: weeks } = await codeApi.getAvailableAcademicYearWeeks(newValue.id);
      this.model.search.collections.weekNumbers = [...weeks];
    }
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      const { data: academicYears } = await academicYearApi.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = [...academicYears];

      const { data: services } = await codeApi.getDisciplineTypeServices();
      this.model.search.collections.serviceTypes = [...services];
    },
    async onAcademicYearChange() {
      const academicYearId = this.model.search.filters.academicYear?.id;
      
      const { data: companies } = await providerApi.getAllProvidertCompaniesByYear({ academicYearId });
      this.model.search.collections.companies = [...companies];

      const { data: regions } = await locationApi.getRegions({ academicYearId });
      this.model.search.collections.regions = [...regions];

      const { data: months } = await academicYearApi.getMonthsInAcademicYear(academicYearId);
      this.model.search.collections.months = [...months];
    },
    async onProviderChange() {
      const academicYearId = this.model.search.filters.academicYear?.id;
      const companyId = this.model.search.filters.company?.id;
      const { data: specialists } = await specialistApi.getSpecialistProvider({ academicYearId, companyId });
      this.model.search.collections.specialists = [...specialists];
    },
    async onHandlerSearch() {
      if (!this.model.search.filters.academicYear?.id
        || !this.model.search.filters.company?.id
      ) return;
      this.process();
    },
    async process() {
      const payload = {
        academicYearId: this.model.search.filters.academicYear?.id,
        companyId: this.model.search.filters.company?.id,
        specialistId: this.model.search.filters.specialist?.id,
        serviceTypeId: this.model.search.filters.serviceType?.id,
        regionId: this.model.search.filters.region?.id,
        monthNumber: this.model.search.filters.month?.id,
        studentSieId: isNaN(this.model.search.filters.studentSieId)
          ? null : Number(this.model.search.filters.studentSieId),
        weekNumberId: this.model.search.filters.weekNumber?.id,
      };

      reportApi
        .getReport('weeklyvisitsregistry', payload)
        .then((res) => DocumentsService.Download(res.data));
    },
  },
}
</script>